/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: analytics.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  GetAgentsListRequest,
  GetAgentsListResponse,
  GetAgentsSummaryRequest,
  GetAgentsSummaryResponse,
  GetOrgAnalyticsRequest,
  GetOrgAnalyticsResponse,
  GetQuestionDetailRequest,
  GetQuestionDetailResponse,
  GetQuestionEvaluationsRequest,
  GetQuestionEvaluationsResponse,
} from '../types/analytics';

export const createAnalyticsService = (transport: Transport) => ({
  async getOrgAnalytics(
    request: GetOrgAnalyticsRequest,
    options: RequestOptions = {},
  ): Promise<GetOrgAnalyticsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.AnalyticsService.GetOrgAnalytics, { organization_id });
    return transport.get<GetOrgAnalyticsResponse>(url, { params, ...options });
  },

  async getAgentsSummary(
    request: GetAgentsSummaryRequest,
    options: RequestOptions = {},
  ): Promise<GetAgentsSummaryResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.AnalyticsService.GetAgentsSummary, { organization_id });
    return transport.get<GetAgentsSummaryResponse>(url, { params, ...options });
  },

  async getAgentsList(
    request: GetAgentsListRequest,
    options: RequestOptions = {},
  ): Promise<GetAgentsListResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.AnalyticsService.GetAgentsList, { organization_id });
    return transport.get<GetAgentsListResponse>(url, { params, ...options });
  },

  async getQuestionDetail(
    request: GetQuestionDetailRequest,
    options: RequestOptions = {},
  ): Promise<GetQuestionDetailResponse> {
    const { organization_id, metric_key, ...params } = request;
    const url = getApiPath(API_METHODS.AnalyticsService.GetQuestionDetail, {
      organization_id,
      metric_key,
    });
    return transport.get<GetQuestionDetailResponse>(url, { params, ...options });
  },

  async getQuestionEvaluations(
    request: GetQuestionEvaluationsRequest,
    options: RequestOptions = {},
  ): Promise<GetQuestionEvaluationsResponse> {
    const { organization_id, metric_key, ...params } = request;
    const url = getApiPath(API_METHODS.AnalyticsService.GetQuestionEvaluations, {
      organization_id,
      metric_key,
    });
    return transport.get<GetQuestionEvaluationsResponse>(url, { params, ...options });
  },
});

export type AnalyticsService = ReturnType<typeof createAnalyticsService>;
